import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";

Vue.use(Vuex);

const root = process.env.VUE_APP_API;
const mode = process.env.VUE_APP_MODE;
const getUserDataAPI = root + "/api/auth/load_userdata";
const loadSidemenuOptionAPI = root + "/api/search/sidemenu_option";

function normSns(v) {
  const s = (v || "").toString().toLowerCase();
  if (s === "tiktok") return "tiktok";
  if (s === "x" || s === "twitter") return "x";
  return "instagram";
}
function normList(v) {
  return (v || "").toString() === "post" ? "post" : "influencer";
}
export default new Vuex.Store({
  state: {
    report_post_override_map: {},
    app_ver: "",
    mode: mode,
    old_app: false,
    dark_mode: true,
    admin_mode: false,
    header_notification: false,
    client_name: "",
    person_name: "",
    ig_info: [],
    ig_selected: [],
    ig_connect_limit: 0,
    window_switch: true,
    email: "",
    email_private: "",
    img_url: "",
    token: "",
    user_token: "",
    permission: [],
    member_info: [],
    intercom_hash: "",
    id_session: "",
    activeMenu: "dashboard",
    activate: "",
    activate_at: "",
    trial_expiration_at: "",
    openMenu: "",
    isSideMenuClosed: false,
    sns_type: "instagram",
    post_type: "feed",
    list_sns_type: "all",
    list_view_style: "pagination",
    phrase_sort_key: "created_at",
    phrase_sort_order: "desc",
    sidemenu_option: [],
    service_plan: [],
    client_select: {
      target_client_id: "all",
    },
    member_select: {
      person_id: "all",
    },
    tag_select: {
      id: "all",
    },
    list_search_word: "",
    list_search: false,
    unpermitted_drawer: false,
    max_tracnking_number: 0,
    form: {},
    form_youtube: {},
    form_tt: {},
    form_tw: {},
    form_initial: {
      account_name: "",
      keyword: "",
      exclude_keyword: "",
      gender_female: true,
      gender_male: true,
      gender_other: true,
      gender_null: false,
      followers: [0, 500000],
      average_engagement_rate: [0, 10],
      female_ratio: [0, 100],
      age: [15, 55],
      score: [0, 100],
      average_video_play_count: [0, 500000],
      category: [],
      area: [],
      radio: 1,
      exclude_list: [],
      exclude_badge: "",
      exclude_favorite: "",
      main_audience: "",
      main_audience_percent: [0, 100],
      tags: [],
      weblink: "",
      other_sns_type: "",
      tags_search_type: 1,
      person_title_search_type: 1,
      person_title: [],
      specialty_categories_genres_search_type: 1,
      specialty_categories_genres: [],
      post_format_search_type: 1,
      post_format: [],
      followers_growth_rate_1: true,
      followers_growth_rate_2: true,
      followers_growth_rate_3: true,
      followers_growth_rate_4: true,
      report_record_status: 0,
      report_keyword: "",
      pr_rate: [0, 100],
      has_recent_post_1month: false,
    },
    form_youtube_initial: {
      channel_name: "",
      keyword: "",
      exclude_keyword: "",
      gender_female: true,
      gender_male: true,
      gender_group: true,
      gender_other: true,
      gender_null: false,
      subscriber: [0, 500000],
      viewRate: [0, 100],
      average_viewCount_long_3month:  [0, 500000],
      average_viewCount_short_3month: [0, 500000],
      average_engagement_rate: [0, 10],
      average_viewRate_long_3month:  [0, 100],
      average_viewRate_short_3month: [0, 100],
      female_ratio: [0, 100],
      radio: 1,
      exclude_list: [],
      exclude_favorite: "",
      main_audience: "",
      main_audience_percent: [0, 100],
      tags: [],
      other_sns_type: "",
      tags_search_type: 1,
      prRate_long_3month: [0, 100],
      prRate_short_3month: [0, 100],
      has_recent_post_1month: false,
    },
    form_tt_initial: {
      account_name: "",
      keyword: "",
      exclude_keyword: "",
      gender_female: true,
      gender_male: true,
      gender_group: true,
      gender_other: true,
      gender_null: false,
      followers: [0, 500000],
      heartCount: [0, 5000000],
      average_engagement_rate: [0, 10],
      score: [0, 100],
      playRate: [0, 100],
      average_play_count: [0, 500000],
      female_ratio: [0, 100],
      radio: 1,
      exclude_list: [],
      exclude_badge: "",
      exclude_favorite: "",
      tags: [],
      weblink: "",
      other_sns_type: "",
      tags_search_type: 1,
      pr_rate: [0, 100],
      has_recent_post_1month: false,
    },
    form_tw_initial: {
      account_name: "",
      keyword: "",
      exclude_keyword: "",
      gender_female: true,
      gender_male: true,
      gender_other: true,
      gender_null: false,
      followers: [0, 500000],
      average_engagement_rate: [0, 10],
      frequency: [0, 50],
      female_ratio: [0, 100],
      radio: 1,
      exclude_list: [],
      exclude_badge: "",
      exclude_favorite: "",
      tags: [],
      weblink: "",
      other_sns_type: "",
      tags_search_type: 1,
      category: [],
      pr_rate: [0, 100],
      has_recent_post_1month: false,
    },
    form_post_initial: {
      keyword: "",
      gender_female: true,
      gender_male: true,
      gender_other: true,
      post_type: "all",
      engagement: [0, 10000],
      engagement_rate: [0, 10],
      followers: [0, 500000],
    },
    detail_option: false,
    recent_post_1month: false,
    form_post: {},
    i_search: {},
    y_search: {},
    tt_search: {},
    tw_search: {},
    media_search: {},
    send_option: {
      span: "nomal",
      comment: false,
      comment_text: "",
      mail: false,
      ongoing: false,
      ongoing_type: "later",
      ongoing_date: "",
      ongoing_time: "10:00",
      sendable_time_switch: false,
      sendable_time_start: "10:00",
      sendable_time_end: "19:00",
    },
    list_item: {
      account_name: true,
      channel_name: true,
      gender: false,
      age: false,
      personalized_name: false,
      sns: true,
      bio: true,
      area: false,
      followers: true,
      following: false,
      subscriber: true,
      heartCount: true,
      average_viewCount: true,
      viewRate: false,
      viewRate_long_3month: false,
      viewRate_short_3month: false,
      viewCount_long_3month: true,
      viewCount_short_3month: true,
      like_count: false,
      comments_count: false,
      retweet_count: false,
      share_count: false,
      egr: true,
      egr_only_pr: false,
      pr_rate: false,
      prRate_long_3month: false,
      prRate_short_3month: false,
      frequency: false,
      likeCount: false,
      gender_ratio: true,
      main_audience: false,
      recent_post: true,
      tag: false,
      status: true,
      comment: true,
      num: false,
      created_at: false,
      category: false,
      personal_name: false,
      personal_birthday: false,
      personal_address: false,
      personal_bank: false,
      personal_tel: false,
      personal_email: false,
      personal_belongs: false,
      note: false,
    },
    report_item: {
      account_name: true,
      post_num: true,
      caption: true,
      influencer: true,
      followers_count: true,
      impression: false,
      reach: false,
      engagement_count: true,
      like_count: true,
      comments_count: true,
      save: false,
      share: false,
      play: false,
      impression_rate: false,
      reach_rate: false,
      average_engagement_rate: true,
      average_engagement_impression_rate: false,
      average_engagement_reach_rate: false,
      like_rate: false,
      comments_rate: false,
      save_rate: false,
      share_rate: false,
      play_rate: false,
      cost: true,
      cpf: true,
      cpe: true,
      cpl: false,
      cpc: false,
      cpi: false,
      cpr: false,
      cpsv: false,
      cpsh: false,
      cpp: false,
      gender_ratio: true,
      comment: true,
      timestamp: true
    },
    edit_mode: false,
    instagram_result_loading: false,
    report_item_map: {
      influencer: { instagram: {}, tiktok: {}, x: {} },
      post: { instagram: {}, tiktok: {}, x: {} },
    },
    report_column_list_map: {
      influencer: { instagram: [], tiktok: [], x: [] },
      post: { instagram: [], tiktok: [], x: [] },
    },

  },
  mutations: {
    // mutations に追加
    RESET_REPORT_ITEMS_TO_DEFAULT(state, { sns_type, list_type }) {
      const st = normSns(sns_type);
      const lt = normList(list_type);

      const cols =
          state.report_column_list_map &&
          state.report_column_list_map[lt] &&
          Array.isArray(state.report_column_list_map[lt][st])
              ? state.report_column_list_map[lt][st]
              : [];

      const next = {};
      cols.forEach((c) => {
        const key = c && c.column;
        if (!key) return;

        // locked は常時ON
        if (c.locked === true) {
          next[key] = true;
          return;
        }

        if (c.defaultshow === false) next[key] = false;
        else if (c.defaultshow === true) next[key] = true;
        else if (c.show === false) next[key] = false;
        else next[key] = true;
      });

      if (!state.report_item_map) {
        state.report_item_map = {
          influencer: { instagram: {}, tiktok: {}, x: {} },
          post: { instagram: {}, tiktok: {}, x: {} },
        };
      }

      Vue.set(state.report_item_map[lt], st, next);
      state.report_item = next; // 互換
    },

    SET_REPORT_COLUMN_LIST(state, { sns_type, list_type, column_list }) {
      const st = normSns(sns_type);
      const lt = normList(list_type);

      if (!state.report_column_list_map) {
        Vue.set(state, "report_column_list_map", {
          influencer: { instagram: [], tiktok: [], x: [] },
          post: { instagram: [], tiktok: [], x: [] },
        });
      }
      if (!state.report_column_list_map[lt]) Vue.set(state.report_column_list_map, lt, {});
      Vue.set(state.report_column_list_map[lt], st, Array.isArray(column_list) ? column_list : []);
    },
    RESET_REPORT_ITEMS(state, { sns_type, list_type }) {
      const st = normSns(sns_type);
      const lt = (list_type || "influencer").toString() === "post" ? "post" : "influencer";
      const other = lt === "post" ? "influencer" : "post";

      if (!state.report_item_map?.[lt]) return;
      if (!state.report_item_map?.[other]) return;

      // “未指定=表示”の意味を {} とするなら両方空にする
      Vue.set(state.report_item_map[lt], st, {});
      Vue.set(state.report_item_map[other], st, {});

      state.report_item = {};
    },
    setReportPostOverrideState(state, { report_id, sns_type, post_id, column, value }) {
      const rid = String(report_id ?? "");
      const sns = (sns_type ?? "").toString().toLowerCase() === "tiktok"
          ? "tiktok"
          : ((sns_type ?? "").toString().toLowerCase() === "x" || (sns_type ?? "").toString().toLowerCase() === "twitter")
              ? "x"
              : "instagram";

      if (!state.report_post_override_map) state.report_post_override_map = {};
      if (!state.report_post_override_map[rid]) state.report_post_override_map[rid] = {};
      if (!state.report_post_override_map[rid][sns]) state.report_post_override_map[rid][sns] = {};
      if (!state.report_post_override_map[rid][sns][post_id]) state.report_post_override_map[rid][sns][post_id] = {};

      Vue.set(state.report_post_override_map[rid][sns][post_id], column, value);
    },

    clearReportPostOverridesState(state, { report_id, sns_type }) {
      const rid = String(report_id ?? "");
      const sns = (sns_type ?? "").toString().toLowerCase() === "tiktok"
          ? "tiktok"
          : ((sns_type ?? "").toString().toLowerCase() === "x" || (sns_type ?? "").toString().toLowerCase() === "twitter")
              ? "x"
              : "instagram";

      if (state.report_post_override_map?.[rid]?.[sns]) {
        Vue.delete(state.report_post_override_map[rid], sns);
      }
    },

    initReportItemsFromColumnListState(state, { sns_type, list_type, column_list }) {
      const st = normSns(sns_type);
      const lt = normList(list_type);

      if (!state.report_item_map[lt][st] || Object.keys(state.report_item_map[lt][st]).length === 0) {
        // データが空の時だけ初期値を生成する
        const next = {};
        (column_list || []).forEach((c) => {
          const key = c.column;
          if (!key) return;
          if (c.locked === true) {
            next[key] = true;
          } else {
            next[key] = (c.defaultshow === false) ? false : (c.show === false ? false : true);
          }
        });
        Vue.set(state.report_item_map[lt], st, next);
      }
      // 常に現在のSNS/リストタイプの設定を state.report_item (互換用) に同期
      state.report_item = state.report_item_map[lt][st];
    },
    resetReportItemsState(state, payload) {
      // payload から sns/list を受け取れる形にする
      const sns_type = payload && payload.sns_type ? payload.sns_type : state.sns_type;
      const list_type = payload && payload.list_type ? payload.list_type : "influencer";

      const st = (sns_type || "").toString().toLowerCase() === "tiktok"
          ? "tiktok"
          : ((sns_type || "").toString().toLowerCase() === "x" || (sns_type || "").toString().toLowerCase() === "twitter")
              ? "x"
              : "instagram";
      const lt = (list_type || "").toString() === "post" ? "post" : "influencer";

      // Vuex が保持している column_list_map を優先して初期値生成
      const cols =
          state.report_column_list_map &&
          state.report_column_list_map[lt] &&
          Array.isArray(state.report_column_list_map[lt][st])
              ? state.report_column_list_map[lt][st]
              : null;

      if (cols) {
        const next = {};
        cols.forEach((c) => {
          const key = c && c.column;
          if (!key) return;
          next[key] =
              (c.defaultshow === false) ? false :
                  (c.defaultshow === true) ? true :
                      (c.show === false) ? false :
                          true;
        });

        if (!state.report_item_map) {
          state.report_item_map = { influencer: { instagram: {}, tiktok: {}, x: {} }, post: { instagram: {}, tiktok: {}, x: {} } };
        }
        state.report_item_map[lt][st] = next;

        // 互換
        state.report_item = next;
        return;
      }

      // payload.column_list が来ている場合
      if (payload && Array.isArray(payload.column_list)) {
        const next = {};
        (payload.column_list || []).forEach((c) => {
          const key = c && c.column;
          if (!key) return;
          next[key] = (c.show === false) ? false : true;
        });
        state.report_item = next;
        return;
      }

      //旧固定fallbackはやめる（混ざる原因なので空にする）
      state.report_item = {};
    },

    getUserDataState(state, response) {
      //アカウントの設定項目
      state.client_name = response.client_name;
      state.person_name = response.member_info.person_name;
      state.email = response.email;
      state.email_private = response.member_info.email;
      state.member_info = response.member_info;
      state.permission = response.member_info.permitted_list;
      state.ig_info = response.ig_info;
      state.id_session = response.id_session;
      state.token = response.token;
      state.user_token = response.user_token;
      state.intercom_hash = response.intercom_hash;
      state.activate = response.activate;
      state.activate_at = response.activate_at;
      state.trial_expiration_at = response.trial_expiration_at;
      state.img_url = response.img_url;
      state.header_notification = response.header_notification;
      state.ig_connect_limit = response.ig_connect_limit;
      state.max_tracking_number = response.max_tracking_number;
      state.manage_member_limit_num = response.manage_member_limit_num;
      const latestAppVer = response.latest_app_ver;
      if (latestAppVer) {
        if (latestAppVer !== state.app_ver) {
          state.old_app = true;
          state.app_ver = latestAppVer;
        } else {
          state.old_app = false;
        }
      } else {
        state.old_app = false;
      }
      //メンバー別の設定項目
      function isRangePair(v) {
        return Array.isArray(v) && v.length === 2;
      }
      function normalizeForm(obj, initial, prev) {
        const form = Object.assign({}, initial || {}, prev || {}, obj || {});

        Object.keys(initial || {}).forEach((k) => {
          if (!isRangePair(initial[k])) return;

          if (isRangePair(form[k])) return;

          const p = prev && prev[k];
          form[k] = isRangePair(p) ? p : initial[k];
        });
        return form;
      }

      const msi = (response && response.member_setting_info) ? response.member_setting_info : {};
      state.form         = normalizeForm(msi.form,        state.form_initial,        state.form);
      state.form_youtube = normalizeForm(msi.form_youtube,state.form_youtube_initial,state.form_youtube);
      state.form_tt      = normalizeForm(msi.form_tt,     state.form_tt_initial,     state.form_tt);
      state.form_tw      = normalizeForm(msi.form_tw,     state.form_tw_initial,     state.form_tw);
      state.form_post = response.member_setting_info.form_post ? response.member_setting_info.form_post : state.form_post_initial;
      // followers が未定義 or 不正なら補正
      if (!Array.isArray(state.form_post.followers) || state.form_post.followers.length !== 2) {
        Vue.set(state.form_post, 'followers', [0, 500000]);
      }
      state.list_view_style = response.member_setting_info.list_view_style;
      state.phrase_sort_key = response.member_setting_info.phrase_sort ? response.member_setting_info.phrase_sort.sort_key : "created_at";
      state.phrase_sort_order = response.member_setting_info.phrase_sort ? response.member_setting_info.phrase_sort.sort_order : "desc";
      state.edit_mode = response.edit_mode;
      // プランの設定項目
      state.service_plan = response.service_plan_info;
      state.service_plan_list = response.service_plan_list;

    },
    resetState(state) {
      state.client_name = "";
      state.person_name = "";
      state.token = "";
      state.user_token = "";
      state.intercom_hash = "";
      state.id_session = "";
      state.activeMenu = "dashboard";
      state.activate = "";
      state.openMenu = [];
      state.isSideMenuClosed = false;
      state.member_info = [];
      state.i_search = { has_recent_post_1month: false };
      state.y_search = { has_recent_post_1month: false };
      state.tt_search = { has_recent_post_1month: false };
      state.tw_search = { has_recent_post_1month: false };
      state.recent_post_1month = false;
      state.media_search = {
        keyword: "",
        pr: "",
        engagement_min: "",
        engagement_max: "",
        engagement_rate_min: "",
        engagement_rate_max: "",
      };
      state.mode = mode;
      state.ig_selected = [];
      state.edit_mode = false;
      state.service_plan = [];
    },
    resetListItemsState(state) {
      state.list_item = {
        account_name: true,
        channel_name: true,
        gender: false,
        personalized_name: false,
        sns: true,
        bio: false,
        area: false,
        followers: true,
        subscriber: true,
        heartCount: true,
        average_viewCount: true,
        viewRate: false,
        viewRate_long_3month: false,
        viewRate_short_3month: false,
        viewCount_long_3month: true,
        viewCount_short_3month: true,
        view_count: false,
        like_count: false,
        comments_count: false,
        share_count: false,
        egr: true,
        pr_rate: true,
        prRate_long_3month: false,
        prRate_short_3month: false,
        frequency: false,
        likeCount: false,
        gender_ratio: true,
        recent_post: true,
        status: true,
        comment: true,
        num: false,
        category: false,
        personal_name: false,
        personal_birthday: false,
        personal_address: false,
        personal_bank: false,
        personal_tel: false,
        personal_email: false,
        personal_belongs: false,
        note: false,
        score: true,
      };
    },
    displayModeState(state) {
      state.dark_mode = !state.dark_mode;
    },
    adminModeState(state) {
      state.admin_mode = !state.admin_mode;
    },
    adminModeOnState(state) {
      state.admin_mode = true;
    },
    changeActivateState(state, value) {
      state.activate = value;
    },
    changeActiveState(state, value) {
      state.activeMenu = value;
    },
    changeOpenedsState(state, value) {
      state.openMenu = value;
    },
    changeIsSideMenuClosedState(state, value) {
      state.isSideMenuClosed = value;
    },
    snsTypeState(state, value) {
      state.sns_type = value;
    },
    postTypeState(state, value) {
      state.post_type = value;
    },
    i_searchState(state, value) {
      state.i_search = Object.assign({}, state.i_search || {}, value || {});
    },
    y_searchState(state, value) {
      state.y_search = Object.assign({}, state.y_search || {}, value || {});
    },
    tt_searchState(state, value) {
      state.tt_search = Object.assign({}, state.tt_search || {}, value || {});
    },
    tw_searchState(state, value) {
      state.tw_search = Object.assign({}, state.tw_search || {}, value || {});
    },
    formState(state, value) {
      state.form = value;
    },
    form_youtubeState(state, value) {
      state.form_youtube = value;
    },
    form_ttState(state, value) {
      state.form_tt = value;
    },
    form_twState(state, value) {
      state.form_tw = value;
    },
    form_postState(state, value) {
      state.form_post = value;
    },
    showDetailOptionState(state) {
      state.detail_option = !state.detail_option;
    },
    media_searchState(state, value) {
      state.media_search = value;
    },
    windowSwitchState(state, value) {
      state.window_switch = value;
    },
    send_optionState(state, value) {
      state.send_option = value;
    },
    saveListItemsState(state, value) {
      state.list_item = value;
    },
    saveReportItemsState(state, value) {
      // 新形式：{ sns_type, list_type, items }
      if (value && typeof value === "object" && value.items && (value.sns_type || value.list_type)) {
        const st = (value.sns_type || "").toString().toLowerCase() === "tiktok"
            ? "tiktok"
            : ((value.sns_type || "").toString().toLowerCase() === "x" || (value.sns_type || "").toString().toLowerCase() === "twitter")
                ? "x"
                : "instagram";
        const lt = (value.list_type || "").toString() === "post" ? "post" : "influencer";

        const cols =
            state.report_column_list_map &&
            state.report_column_list_map[lt] &&
            Array.isArray(state.report_column_list_map[lt][st])
                ? state.report_column_list_map[lt][st]
                : [];

        const next = { ...(value.items || {}) };
        cols.forEach((c) => {
          const key = c && c.column;
          if (!key) return;
          if (c.locked === true) next[key] = true;
        });

        if (!state.report_item_map) {
          state.report_item_map = { influencer: { instagram: {}, tiktok: {}, x: {} }, post: { instagram: {}, tiktok: {}, x: {} } };
        }
        state.report_item_map[lt][st] = next;
        state.report_item = next;
        return;
      }
      state.report_item = value;
    },
    changeIGAccountState(state, value) {
      state.ig_selected = value;
    },
    IGAccountUpdateState(state, value) {
      Vue.set(state.ig_selected, "unseen_count", value);
    },
    selectClientState(state, value) {
      state.client_select = value;
    },
    selectMemberState(state, value) {
      state.member_select = value;
    },
    selectTagState(state, value) {
      state.tag_select = value;
    },
    changeListViewState(state, value) {
      state.list_view_style = value;
    },
    privateEmailState(state, value) {
      state.email_private = value;
    },
    changeListSnsTypeState(state, value) {
      state.list_sns_type = value;
    },
    headerNotificationState(state, value) {
      state.header_notification = value;
    },
    openUnpermittedDrawerState(state, value) {
      state.unpermitted_drawer = value;
    },
    searchListState(state, { list_search_word, list_search }) {
      state.list_search_word = list_search_word;
      state.list_search = list_search;
    },
    phraseSortState(state, { sort_key, sort_order }) {
      state.phrase_sort_key = sort_key;
      state.phrase_sort_order = sort_order;
    },
    loadSidemenuOptionState(state, response) {
      state.sidemenu_option = response;
    },
    changeEditModeState(state, value) {
      state.edit_mode = value
    },
    instagramResultLoadingState(state, value) {
      state.instagram_result_loading = value
    },
    recentPost1monthState(state, value) {
      state.recent_post_1month = !!value;
    },
  },
  actions: {
    // actions に追加
    setReportColumnList({ commit }, { sns_type, list_type, column_list }) {
      commit("SET_REPORT_COLUMN_LIST", { sns_type, list_type, column_list });
    },
    setReportPostOverride({ commit }, payload) {
      commit("setReportPostOverrideState", payload);
    },
    clearReportPostOverrides({ commit }, payload) {
      commit("clearReportPostOverridesState", payload);
    },
    initReportItemsFromColumnList({ commit }, { sns_type, list_type, column_list }) {
      const lt = normList(list_type);
      const other = lt === "post" ? "influencer" : "post";

      // 既存仕様：post と influencer を同一 SNS で連動させる
      commit("initReportItemsFromColumnListState", { sns_type, list_type: lt, column_list });
      commit("initReportItemsFromColumnListState", { sns_type, list_type: other, column_list });
    },
    resetReportItemsFromColumnList({ commit }, payload) {
      commit("resetReportItemsState", payload);
    },
    getUserData({ commit }, { token, user_token }) {
      return axios
          .get(getUserDataAPI, {
            params: {
              token: token,
              user_token: user_token,
            },
          })
          .then((response) => {
            commit("getUserDataState", response.data);
          });
    },
    reset({ commit }) {
      commit("resetState");
    },
    displayMode({ commit }) {
      commit("displayModeState");
    },
    adminMode({ commit }) {
      commit("adminModeState");
    },
    adminModeOn({ commit }) {
      commit("adminModeOnState");
    },
    changeActivate({ commit }, value) {
      commit("changeActivateState", value);
    },
    changeActive({ commit }, value) {
      commit("changeActiveState", value);
    },
    changeOpeneds({ commit }, value) {
      commit("changeOpenedsState", value);
    },
    changeIsSideMenuClosed({ commit }, value) {
      commit("changeIsSideMenuClosedState", value);
    },
    snsType({ commit }, value) {
      commit("snsTypeState", value);
    },
    postType({ commit }, value) {
      commit("postTypeState", value);
    },
    i_search({ commit }, value) {
      commit("i_searchState", value);
    },
    y_search({ commit }, value) {
      commit("y_searchState", value);
    },
    tt_search({ commit }, value) {
      commit("tt_searchState", value);
    },
    tw_search({ commit }, value) {
      commit("tw_searchState", value);
    },
    form({ commit }, value) {
      commit("formState", value);
    },
    form_youtube({ commit }, value) {
      commit("form_youtubeState", value);
    },
    form_tt({ commit }, value) {
      commit("form_ttState", value);
    },
    form_tw({ commit }, value) {
      commit("form_twState", value);
    },
    form_post({ commit }, value) {
      commit("form_postState", value);
    },
    showDetailOption({ commit }) {
      commit("showDetailOptionState");
    },
    windowSwitch({ commit }, value) {
      commit("windowSwitchState", value);
    },
    send_option({ commit }, value) {
      commit("send_optionState", value);
    },
    media_search({ commit }, value) {
      commit("media_searchState", value);
    },
    saveListItems({ commit }, value) {
      commit("saveListItemsState", value);
    },
    resetListItems({ commit }, value) {
      commit("resetListItemsState", value);
    },
    saveReportItems({ commit, state }, { sns_type, list_type, items }) {
      const st = normSns(sns_type);
      const lt = (list_type || "influencer").toString() === "post" ? "post" : "influencer";
      const other = lt === "post" ? "influencer" : "post";

      commit("saveReportItemsState", { sns_type, list_type: lt, items });
      const otherCur = state.report_item_map?.[other]?.[st] || {};
      const merged = { ...otherCur, ...(items || {}) };

      commit("saveReportItemsState", { sns_type: st, list_type: other, items: merged });
    },
    resetReportItems({ commit }, { sns_type, list_type }) {
      const lt = normList(list_type);
      commit("RESET_REPORT_ITEMS_TO_DEFAULT", { sns_type, list_type: lt });
    },
    changeIGAccount({ commit }, value) {
      commit("changeIGAccountState", value);
    },
    IGAccountUpdate({ commit }, value) {
      commit("IGAccountUpdateState", value);
    },
    selectClient({ commit }, value) {
      commit("selectClientState", value);
    },
    selectMember({ commit }, value) {
      commit("selectMemberState", value);
    },
    selectTag({ commit }, value) {
      commit("selectTagState", value);
    },
    changeListView({ commit }, value) {
      commit("changeListViewState", value);
    },
    privateEmail({ commit }, value) {
      commit("privateEmailState", value);
    },
    searchList({ commit }, { list_search_word, list_search }) {
      commit("searchListState", { list_search_word, list_search });
    },
    changeListSnsType({ commit }, value) {
      commit("changeListSnsTypeState", value);
    },
    headerNotification({ commit }, value) {
      commit("headerNotificationState", value);
    },
    openUnpermittedDrawer({ commit }, value) {
      commit("openUnpermittedDrawerState", value);
    },
    phraseSort({ commit }, { sort_key, sort_order }) {
      commit("phraseSortState", { sort_key, sort_order });
    },
    loadSidemenuOption({ commit }, token) {
      axios
          .get(loadSidemenuOptionAPI, {
            params: {
              token: token,
            },
          })
          .then((response) => {
            commit("loadSidemenuOptionState", response.data);
          });
    },
    changeEditMode({ commit }, value) {
      commit("changeEditModeState", value);
    },
    instagram_result_loading({ commit }, value) {
      commit("instagramResultLoadingState", value);
    },
    recent_post_1month({ commit }, value) {
      commit("recentPost1monthState", value);
    },
  },
  plugins: [
    createPersistedState({
      // key: 'REECHApp',
      // paths: ['token'],
      //cookieのサイズが4095bを超えると保存されないため、cookieに保存するstateを個別で指定
      reducer: (state) => ({
        report_column_list_map: state.report_column_list_map,
        app_ver: state.app_ver,
        mode: state.mode,
        old_app: state.old_app,
        dark_mode: state.dark_mode,
        admin_mode: state.admin_mode,
        header_notification: state.header_notification,
        ig_selected: state.ig_selected,
        list_item: state.list_item,
        report_item: state.report_item,
        report_item_map: state.report_item_map,
        window_switch: state.window_switch,
        token: state.token,
        user_token: state.user_token,
        id_session: state.id_session,
        activeMenu: state.activeMenu,
        activate: state.activate,
        openMenu: state.openMenu,
        isSideMenuClosed: state.isSideMenuClosed,
        sns_type: state.sns_type,
        post_type: state.post_type,
        send_option: state.send_option,
        detail_option: state.detail_option,
        recent_post_1month: state.recent_post_1month,
        client_select: state.client_select,
        member_select: state.member_select,
        tag_select: state.tag_select,
        edit_mode: state.edit_mode,
        i_search: state.i_search,
        y_search: state.y_search,
        tt_search: state.tt_search,
        tw_search: state.tw_search,
      }),
      storage: {
        getItem: (key) => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value, { expires: 30, secure: true }),
        removeItem: (key) => Cookies.remove(key),
      },
    }),
  ],
});
